import type { ApprovalRole } from '@tto/shared-models';
import { ENDPOINT } from '../config/apiTags';
import { baseApi } from './baseApi.service';

const APPROVAL_ENDPOINT_BY_ROLE: Record<ApprovalRole, string> = {
  contributor: ENDPOINT.CONTRIBUTORS,
  hod: ENDPOINT.HOD,
  dean: ENDPOINT.DEAN,
  drd: ENDPOINT.DRD,
  'tto-director': ENDPOINT.TTO_DIRECTOR,
};

type ResolveApprovalLinkArgs = {
  role: ApprovalRole;
  token: string;
  __silenceToast?: boolean;
};

export interface ApprovalResponse {
  url: string;
}

export interface ApprovalError {
  status: number;
  data: { message?: string } | null;
}

const approvalApi = baseApi.injectEndpoints({
  endpoints: (builder) => ({
    resolveApprovalLink: builder.mutation<ApprovalResponse, ResolveApprovalLinkArgs>({
      queryFn: async ({ role, token }) => {
        try {
          const response = await fetch(
            `${process.env.REACT_APP_BASE_API_URL}${APPROVAL_ENDPOINT_BY_ROLE[role]}/approval-redirect`,
            {
              method: 'POST',
              headers: {
                'Content-Type': 'application/json',
              },
              body: JSON.stringify({ token }),
            },
          );

          const data = await response.json().catch(() => null);

          if (!response.ok) {
            return {
              error: {
                status: response.status,
                data,
              } as ApprovalError,
            };
          }

          return { data: data as ApprovalResponse };
        } catch {
          return {
            error: {
              status: 500,
              data: null,
            } as ApprovalError,
          };
        }
      },
    }),
  }),
});

export const { useResolveApprovalLinkMutation } = approvalApi;
